// src/Adminstrator/InspectorMaster.js
import React, { useState } from 'react';
import axios from 'axios';
import GetDistricts from "../Dropdowns/getDistricts";

const InspectorMaster = () => {
    const [form, setForm] = useState({
        distCode: '',
        inspDesg: '',
        inspName: '',
        inspUid: '',
        inspMobile: ''
    });

    const [message, setMessage] = useState('');
    const [list, setList] = useState([]);
    const [loadingDistrict, setLoadingDistrict] = useState(true);

    const handleDistrictChange = (value) => {
        setForm({ ...form, distCode: value });
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.distCode) {
            setMessage("Please select District");
            return;
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_URL}/api/inspector/add`,
                {
                    distCode: form.distCode,
                    inspDesg: form.inspDesg.trim(),
                    inspName: form.inspName.trim(),
                    inspUid: form.inspUid.trim(),
                    inspMobile: form.inspMobile.trim() || null
                },
                { withCredentials: true }
            );

            setMessage(res.data.message);
            setList(res.data.list);

            setForm({
                ...form,
                inspDesg: '',
                inspName: '',
                inspUid: '',
                inspMobile: ''
            });

        } catch (err) {
            setMessage(err.response?.data?.message || "Failed to add inspector");
        }
    };

    return (
        <>
            <div className="container-fluid" style={{ marginTop: "30px" }}>


                <form onSubmit={handleSubmit}>
                    <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>

                        <thead>
                            <tr className='tableheader'>
                                <th colSpan="2" > Inspector Details</th> </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="left">
                                    District
                                </td>
                                <td align="left" >
                                    <GetDistricts
                                        onLoadingChange={setLoadingDistrict}
                                        onChange={handleDistrictChange}
                                    />
                                    {loadingDistrict && <span style={{ color: "#666" }}>Loading districts...</span>}
                                </td>
                            </tr>

                            <tr>
                                <td align="left" >
                                    Inspector Name
                                </td>
                                <td align="left" >
                                    <input
                                        type="text"
                                        name="inspName"
                                        value={form.inspName}
                                        onChange={handleChange}
                                        placeholder="Enter Inspector Name"
                                        required
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td align="left" >
                                    Inspector Desg.
                                </td>
                                <td align="left" >
                                    <input
                                        type="text"
                                        name="inspDesg"
                                        value={form.inspDesg}
                                        onChange={handleChange}
                                        placeholder=""
                                        required
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td align="left">
                                    Inspector UID
                                </td>
                                <td align="left">
                                    <input
                                        type="text"
                                        name="inspUid"
                                        value={form.inspUid}
                                        onChange={handleChange}
                                        maxLength="12"

                                        placeholder="12-digit Aadhaar"
                                        required
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td align="left" >
                                    Inspector Mobile
                                </td>
                                <td align="left" >
                                    <input
                                        type="text"
                                        name="inspMobile"
                                        value={form.inspMobile}
                                        onChange={handleChange}
                                        maxLength="10"
                                        placeholder="10-digit Mobile"
                                        required
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td colSpan="2" align="center" >
                                    <button
                                        type="submit"
                                        className='button button2'
                                        disabled={loadingDistrict}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        className='button button2'
                                        onClick={() => {
                                            setForm({ ...form, inspDesg: '', inspName: '', inspUid: '', inspMobile: '' });
                                            setMessage('');
                                        }}
                                    >
                                        Back
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
                {message && (
                    <div style={{
                        textAlign: "center",
                        margin: "20px 0",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "brown",
                        textDecoration: "underline",
                        textDecorationThickness: "2px",
                        textDecorationColor: "brown"
                    }}>
                        {message}
                    </div>
                )}

                {list.length > 0 && (
                    <div style={{ marginTop: "50px" }}>
                        <table
                            width="80%"
                            align="center"
                            cellPadding="8"
                            cellSpacing="0"
                        >
                            <thead>
                                <tr className='tableheader'>
                                    <th>Sl.No</th>
                                    <th>Insp Name</th>
                                    <th>Insp Desg</th>
                                    <th>Insp UID</th>
                                    <th>Insp Mobile</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.map((item, index) => (
                                    <tr
                                        key={item.insp_uid}
                                        style={{ backgroundColor: index % 2 === 0 ? "#f0f0f0" : "white" }}
                                    >
                                        <td align="center">{index + 1}</td>
                                        <td align="center">{item.insp_name}</td>
                                        <td align="center">{item.desig}</td>
                                        <td align="center">{item.insp_uid}</td>
                                        <td align="center">{item.insp_mobile || "-NA-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
};

export default InspectorMaster;